var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58002 14.1428C2.61761 14.6467 2.84389 15.1178 3.21365 15.4621C3.58341 15.8064 4.06944 15.9985 4.57468 16.0002H11.4254C11.9306 15.9985 12.4166 15.8064 12.7864 15.4621C13.1561 15.1178 13.3824 14.6467 13.42 14.1428L14.0493 5.3335H1.95068L2.58002 14.1428Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 2.66667H11.3333V0.666667C11.3333 0.489856 11.2631 0.320286 11.1381 0.195262C11.013 0.0702379 10.8435 0 10.6667 0L5.33333 0C5.15652 0 4.98695 0.0702379 4.86193 0.195262C4.7369 0.320286 4.66667 0.489856 4.66667 0.666667V2.66667H0.666667C0.489856 2.66667 0.320286 2.7369 0.195262 2.86193C0.0702379 2.98695 0 3.15652 0 3.33333C0 3.51014 0.0702379 3.67971 0.195262 3.80474C0.320286 3.92976 0.489856 4 0.666667 4H15.3333C15.5101 4 15.6797 3.92976 15.8047 3.80474C15.9298 3.67971 16 3.51014 16 3.33333C16 3.15652 15.9298 2.98695 15.8047 2.86193C15.6797 2.7369 15.5101 2.66667 15.3333 2.66667ZM6 1.33333H10V2.66667H6V1.33333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e0e74bb073cc051053496ef5c520ea1a.svg";
export { ForwardRef as ReactComponent };